import { ParamsWithPagination } from '@/types/api';

import { ChannelRecordingTaskFilters } from '../types';

export const channelRecordingTasksKeys = {
  all: ['channelRecordingTasks'] as const,
  lists: () => [...channelRecordingTasksKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<ChannelRecordingTaskFilters>) =>
    [...channelRecordingTasksKeys.lists(), params] as const,
};
